<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useUserAuthorizationsStore } from '@/store/UserAuthorizationsStore';
import Button from 'primevue/button';
import InputNumber from 'primevue/inputnumber';

const props = defineProps<{
  emailData: object;
  isExpiryDateDeparture?: boolean;
}>();

const emits = defineEmits<{
  handleSubmit: [value: any];
  'update:emailData': [value: any];
}>();

const userAuthorizationsStore = useUserAuthorizationsStore();
const authorizations: any = userAuthorizationsStore.permissionByRole;
const { t } = useI18n({ useScope: 'global' });

const emailType = computed({
  get() {
    return props.emailData;
  },
  set(value) {
    emits('update:emailData', value);
  }
});

const handleUpdateExpired = (type: string, exclusions: any) => {
  const payload = {
    type,
    day: emailType.value.dayDefault,
    dayFromDeparture: emailType.value.dayFromDeparture ?? 0,
    exclusions: exclusions
  };
  emits('handleSubmit', payload);
};

const getTitle = (title: string) => {
  switch (title) {
    case 'emailDepositDue':
      return t('management.email.deposit_due');
    case 'emailPaymentDue':
      return t('management.email.final_payment_due');
    case 'emailPassengerListDue':
      return t('management.email.passenger_list_due');
    case 'emailQuoteExpiring':
      return t('management.email.quote_expiring');
    case 'airExp':
      return t('management.email.air_quote');
    case 'cruiseExp':
      return t('management.email.cruise_quote');
    case 'hotelExp':
      return t('management.email.hotel_quote');
    case 'mdtExp':
      return t('advance_quote.form.multi_day_tour');
    default:
      return t('management.email.package_quote');
  }
};

const getType = (keyName: string) => {
  switch (keyName) {
    case 'emailDepositDue':
      return 'EMAIL_DEPOSIT_DUE';
    case 'emailPaymentDue':
      return 'EMAIL_FINAL_PAYMENT_DUE';
    case 'emailPassengerListDue':
      return 'EMAIL_PASSENGER_LIST_DUE';
    case 'emailQuoteExpiring':
      return 'EMAIL_QUOTE_EXPIRING';
    case 'airExp':
      return 'AIR';
    case 'cruiseExp':
      return 'CRUISE';
    case 'hotelExp':
      return 'HOTEL';
    case 'mdtExp':
      return 'MDT';
    default:
      return 'PACKAGE';
  }
};

const isDisable = computed(() => {
  return authorizations?.configurationPage?.configurable_items_edit;
});
</script>
<template>
  <div class="email-config-number">
    <div class="flex mb-3 input-number-field">
      <div class="align-self-center mr-3 w-20rem">
        <div>{{ getTitle(emailType.keyName) }}</div>
        <div v-if="!isExpiryDateDeparture">({{ $t('common.default') }})</div>
      </div>
      <InputNumber :disabled="!isDisable" v-model="emailType.dayDefault" :placeholder="$t('common.7days')" class="mr-3 input-number"></InputNumber>
      <InputNumber v-if="isExpiryDateDeparture" :disabled="!isDisable" v-model="emailType.dayFromDeparture" :placeholder="$t('common.7days')" class="mr-3 input-number"></InputNumber>
      <Button v-if="isDisable" :label="$t('promos.save')" icon="pi pi-check save-btn" class="mr-2 bg-primary" @click="handleUpdateExpired(getType(emailType.keyName), emailType.exclusions)" />
    </div>
  </div>
</template>
